<template>
  <div class="panel panel-default card-view">
    <div class="panel-wrapper collapse in">
      <div class="panel-body">
        <div class="col-md-12">

          <div class="row">
            <span style="float: left;">PF Account</span>
            <span style="float: right;">
              <i class="fa fa-pencil-square-o" aria-hidden="true" v-if="!editData" @click="toggleEditData"></i>
              <i class="fa fa-close" aria-hidden="true" v-if="editData" @click="toggleEditData"></i>
            </span>
          </div>

          <br>

          <div class="row">
            <div class="form-group row">
              <label class="col-sm-4 col-form-label">Is employee covered under PF</label>
              <div class="col-sm-8">
                <p v-if="!editData">{{ form.is_pf_applicable == 1 ? 'YES' : 'NO' }}</p>
                <my-checkbox :selection.sync="form.is_pf_applicable" v-if="editData"></my-checkbox>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-4 col-form-label">UAN Number</label>
              <div class="col-sm-8">
                <p v-if="!editData">{{ form.uan_no }}</p>
                <input v-uppercase type="text" class="form-control" placeholder="UAN Number" v-if="editData" v-model="form.uan_no">
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-4 col-form-label">PAN Number</label>
              <div class="col-sm-8">
                <p v-if="!editData">{{ form.pan_no }}</p>
                <input v-uppercase type="text" class="form-control" placeholder="PAN Number" v-if="editData" v-model="form.pan_no">
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-4 col-form-label">PF Number</label>
              <div class="col-sm-8">
                <p v-if="!editData">{{ form.pf_no }}</p>
                <input v-uppercase type="text" class="form-control" placeholder="PF Number" v-if="editData" v-model="form.pf_no">
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-4 col-form-label">PF Joining Date</label>
              <div class="col-sm-8">
                <p v-if="!editData">{{ form.pf_joining_date | ddmmyyyy }}</p>
                <my-datepicker :date.sync="form.pf_joining_date" placeholder="PF Joining Date" v-if="editData"></my-datepicker>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-4 col-form-label">Family PF Number</label>
              <div class="col-sm-8">
                <p v-if="!editData">{{ form.family_pf_no }}</p>
                <input v-uppercase type="text" class="form-control" placeholder="Family PF Number" v-if="editData" v-model="form.family_pf_no">
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-4 col-form-label">Is Existing Member of EPS</label>
              <div class="col-sm-8">
                <p v-if="!editData">{{ form.is_existing_member_of_eps == 1 ? 'YES' : 'NO' }}</p>
                <my-checkbox :selection.sync="form.is_existing_member_of_eps" v-if="editData"></my-checkbox>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-4 col-form-label">Allow EPF Excess Contribution</label>
              <div class="col-sm-8">
                <p v-if="!editData">{{ form.allow_epf_excess_contribution == 1 ? 'YES' : 'NO' }}</p>
                <my-checkbox :selection.sync="form.allow_epf_excess_contribution" v-if="editData"></my-checkbox>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-4 col-form-label">Allow EPS Excess Contribution</label>
              <div class="col-sm-8">
                <p v-if="!editData">{{ form.allow_eps_excess_contribution == 1 ? 'YES' : 'NO' }}</p>
                <my-checkbox :selection.sync="form.allow_eps_excess_contribution" v-if="editData"></my-checkbox>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-sm-10"
                v-if="editData"
              >
                <submit-button :isLoading="isLoading" @submit="update" text="Update"></submit-button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
export default {
  data () {
    return {
      editData: false,
    }
  },
  props: ['form', 'isLoading'],
  methods: {
    toggleEditData() {
      this.editData = !this.editData
    },
    cancelUpdate() {
      this.editData = false
    },
    async update() {
      this.$emit('update')
      this.editData = false
    }
  }
}
</script>